export default __webpack_public_path__ + "static/spet2-e64e588526b814576afff8078db613af.png";